exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".center-info-a {\n  color: OliveDrab;\n  font-style: italic; }\n\n.center-info-b {\n  color: OliveDrab;\n  font-style: italic;\n  font-weight: bold; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/home/rob/Staxi/client/src/app/main/transportations/transportations.component.sass
// module id = ../../../../../src/app/main/transportations/transportations.component.sass
// module chunks = main